(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-code-body"] && !Shopify.designMode) return;
  try {
    function moveVariantPicker() {
    const wrapper = document.querySelector(".m-product-info--wrapper");
    const variantPicker = wrapper?.querySelector(".main-product__block-variant_picker");

    if (!wrapper || !variantPicker) return;

    if (window.innerWidth <= 767) {
      wrapper.insertBefore(variantPicker, wrapper.firstElementChild);
    }
  }

  document.addEventListener("DOMContentLoaded", moveVariantPicker);
  window.addEventListener("resize", moveVariantPicker);
  } catch(e) { console.error(e); }
})();

})();
